module.exports = "../../app/cells/components/offers/offer_cell.rb";